import { ButtonLink } from '../components/Button';
import { EmptyBoard } from '../components/illustrations';
import { Paper } from '../components/Paper';
import { EmptyState } from '../components/States';
import { useMe } from '../features/auth/session';
import { BoardHeader } from '../features/feed/BoardHeader';
import { Composer } from '../features/feed/Composer';
import { FeedList } from '../features/feed/FeedList';
import styles from './Page.module.css';
import { FEED_REACH } from '../../shared/region';

export function Home() {
  const { data: me } = useMe();

  if (!me?.location) {
    return (
      <Paper>
        <EmptyState
          art={<EmptyBoard />}
          title="Verify your home to see a board"
          actions={
            <ButtonLink to="/me/location" variant="primary">
              Verify my location
            </ButtonLink>
          }
        >
          Boards are built around where you live. Moderators can still use the moderation tools without one.
        </EmptyState>
      </Paper>
    );
  }

  return (
    <div className={styles.stack}>
      <BoardHeader place={me.location.placeName} />
      <Composer />
      <FeedList
        filter={{}}
        empty={
          <Paper>
            <EmptyState art={<EmptyBoard />} title="The board is quiet">
              <p>
                Nobody within {FEED_REACH} has posted yet. Say hello, ask a question, or tell a neighbor about
                Roadrunner. The board fills up one note at a time.
              </p>
            </EmptyState>
          </Paper>
        }
      />
    </div>
  );
}
